module.exports = __webpack_public_path__ + "static/media/favicon.c3150b75.ico";